import React from "react";
//
import InfoIcon from "@limitless/icons/InfoCircle";
import CheckCircle from "@limitless/icons/CheckCircle";
import ErrorIcon from "@limitless/icons/ExclamationOctagon";
export const getAlertOverrides = theme => ({
  MuiAlert: {
    defaultProps: {
      iconMapping: {
        info: /*#__PURE__*/React.createElement(InfoIcon, {
          sx: {
            color: theme.palette.primary.main
          }
        }),
        success: /*#__PURE__*/React.createElement(CheckCircle, {
          sx: {
            color: theme.palette.success.main
          }
        }),
        error: /*#__PURE__*/React.createElement(ErrorIcon, {
          sx: {
            color: theme.palette.error.dark
          }
        })
      }
    },
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.default,
        borderRadius: "4px"
      },
      standardSuccess: {
        color: theme.palette.success.main
      },
      standardInfo: {
        color: theme.palette.primary.dark
      },
      standardError: {
        color: theme.palette.error.dark
      },
      action: {
        padding: "0px 0px 0px 16px",
        height: 20
      },
      icon: {
        padding: 0,
        marginRight: "16px"
      },
      message: {
        padding: 0
      }
    }
  }
});